import type { ModelProductsSearchFilter } from '@app/api/Products';

export const PF = 'product-directory';

export const initialFilters: ModelProductsSearchFilter = {
  SearchTerm: null,
  CategoryIds: null,
  BrandIds: null,
  ItemsPerPage: 20,
  PageN: 1,
};
